import { useEffect, useState, forwardRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DisputeDialog = ({ open, close, invoiceId }) => {
  const [body, setBody] = useState("");

  const handleDispute = async () => {
    const payload = {
      invoiceId,
      body
    };
    const result = await request('contracts/invoice/dispute', 'post', payload);
    if (result.success) {
      toast.success("Dispute logged successfully");
      setBody("");
      close();
    }
  }

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1 }}>
            Dispute Invoice
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent
        style={{ display: "flex", flexDirection: "column", gap: 20 }}
      >
        <Typography>
          Please provide details as to why you are disputing this invoice
        </Typography>
        <TextField
          value={body}
          onChange={(e) => setBody(e.target.value)}
          multiline
          rows={5}
          style={{ width: "100%" }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDispute}>Submit</Button>
        <Button
          onClick={() => {
            setBody("");
            close();
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisputeDialog;
